module.exports = __webpack_public_path__ + "assets/img/financing.7537ab2c.jpg";